// extracted by mini-css-extract-plugin
export var linkText = "_pn-0";